module.exports = __webpack_public_path__ + "img/icon_map_64_off.0e5ba1d0.png";